import { render, staticRenderFns } from "./innovationCenSwiper.vue?vue&type=template&id=07fbac71&scoped=true"
import script from "./innovationCenSwiper.vue?vue&type=script&lang=js"
export * from "./innovationCenSwiper.vue?vue&type=script&lang=js"
import style1 from "./innovationCenSwiper.vue?vue&type=style&index=1&id=07fbac71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fbac71",
  null
  
)

export default component.exports